exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".textTable table{font-size:.8em;width:100%}.textTable td.editable a{font-size:.8em;float:right;margin-top:2px}.textTable td.editable .editIcon{position:relative;left:5px;margin-top:2px;float:right}.textTable td{vertical-align:middle!important}.textTable th.bookCol{width:30%}.textTable th.quizCol,.textTable th.writingCol{min-width:7.7em}.textTable th.answerCol,.textTable th.responseCol,.textTable th.reviewCol,.textTable th.textVarietyCol{min-width:5em}.textTable th.ReadingLevelCol{min-width:6em}.textTable .scoreDisplay{display:inline-block;margin-right:.4em}.textTable .textVarietyDisplay{margin-right:.4em}.textTable .truncatedPlaceholder td{text-align:center}.textTable .truncatedPlaceholder td .btn{position:relative;bottom:1px}.textTable .textRow td.writingCount{padding:5px}.textTable .textRow td.writingCount .hideOnPrint{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/reading/books/text_table.scss
// module id = 1358
// module chunks = 0